import { render, staticRenderFns } from "./CertificateRequestFormView.vue?vue&type=template&id=560c96c0&"
import script from "./CertificateRequestFormView.vue?vue&type=script&lang=ts&"
export * from "./CertificateRequestFormView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports